import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// import api from "@/utils/backend-api"
import user from './modules/user'
import project from './modules/project'
import profile from './modules/profile'
import calendar from './modules/calendar'
Vue.use(Vuex)

export default new Vuex.Store({
  // strict: true,
  // enable for debug
  // plugins: [createPersistedState({ storage: window.sessionStorage })],
  // enable in prod
  plugins: [createPersistedState()],
  modules: {
    user,
    project,
    profile,
    calendar
    // customers
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js